var map = {
	"./AboutComponent.vue": 317,
	"./ContactComponent.vue": 877,
	"./GalleryComponent.vue": 177,
	"./HomeBannerComponent.vue": 577,
	"./PricesComponent.vue": 669,
	"./ReferenceComponent.vue": 343,
	"./standard/FooterComponent.vue": 237,
	"./standard/HeaderComponent.vue": 325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 997;